import { setCustomYupValidatorsErrorMessages, yup } from '@faceup/validation'
import { sharedMessages } from '../Shared/translations'
import { defineMessages, useIntl } from '../TypedIntl'

const messages = defineMessages({
  validationStringMin: 'Shared.validation.string.min',
  validationStringMax: 'Shared.validation.string.max',
  validationArrayMin: 'Shared.validation.array.min',
  validationArrayMax: 'Shared.validation.array.max',
  invalidEmail: 'Shared.validation.custom.email.invalid',
  invalidUrl: 'Shared.validation.custom.url.invalid',
  invalidIpAddress: 'Shared.validation.custom.ipAddress.invalid',
  invalidPhone: 'Shared.validation.custom.phone.invalid',
  invalidFile: 'Shared.validation.custom.file.invalid',
  invalidUuid: 'Shared.validation.custom.uuid.invalid',
})

/**
 * Applies the app's localized yup error messages to the global yup locale.
 * Call once high in the tree (inside an IntlProvider). Runs on every render so
 * the locale stays in sync when the language changes.
 */
export const useYupLocalization = () => {
  const { formatMessage } = useIntl()

  yup.setLocale({
    mixed: {
      default: formatMessage(sharedMessages.invalidInputError),
      required: formatMessage(sharedMessages.invalidInputError),
      notOneOf: formatMessage(sharedMessages.invalidInputError),
      oneOf: formatMessage(sharedMessages.invalidInputError),
    },
    string: {
      min: ({ min }) => formatMessage(messages.validationStringMin, { min }),
      max: ({ max }) => formatMessage(messages.validationStringMax, { max }),
    },
    array: {
      min: ({ min }) => formatMessage(messages.validationArrayMin, { min }),
      max: ({ max }) => formatMessage(messages.validationArrayMax, { max }),
    },
  })

  setCustomYupValidatorsErrorMessages({
    email: formatMessage(messages.invalidEmail),
    url: formatMessage(messages.invalidUrl),
    ipAddress: formatMessage(messages.invalidIpAddress),
    phone: formatMessage(messages.invalidPhone),
    file: formatMessage(messages.invalidFile),
    uuid: formatMessage(messages.invalidUuid),
  })
}
